var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"info-block",class:{ 'info-block-solid-border': _vm.borderSolid, 'info-block-dashed-border': _vm.borderDashed },style:(_vm.styles),attrs:{"color":`#${_vm.color}`,"flat":"","data-testid":"elem_u_000859"}},[_c('v-card-text',{staticClass:"info-block-wrapper",attrs:{"data-testid":"elem_u_000860"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }